'use strict';

module.exports = function ($stateProvider) {
    $stateProvider
    // USER MANAGEMENT
    .state('pages.main.manage_users', {
        url: '/manage_users',
        template: require('../views/users/manage_users.html'),
        controller: 'manageUserController',
        controllerAs: 'page',
        data: {
            title: 'User Management',
            daterange: false
        }
    })
}


/** WEBPACK FOOTER **
 ** ./src/pages/routes/user.js
 **/